var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 1)?_c('div',[(_vm.typeTask >= 0)?_c('m-icon',{staticClass:"task-one-info",attrs:{"icon":_vm.icons[_vm.typeTask],"title":_vm.tooltips[_vm.typeTask],"disabled":!_vm.isPermissionEdit},on:{"click":function($event){return _vm.hadlerClick()}}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }